var _excluded = ["locale", "type"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var setCharAt = (text, index, newText) => {
  if (index > text.length - 1) return text;
  return text.substring(0, index) + newText + text.substring(index + 1);
};

export var patternMask = function patternMask(value, pattern) {
  var _value, _pattern, _pattern$slice, _pattern$slice$split, _formattedText;

  if (value === void 0) {
    value = '';
  }

  if (pattern === void 0) {
    pattern = '';
  }

  var formattedText = (_value = value) == null ? void 0 : _value.replace(/\D/g, '');
  (_pattern = pattern) == null ? void 0 : (_pattern$slice = _pattern.slice()) == null ? void 0 : (_pattern$slice$split = _pattern$slice.split('')) == null ? void 0 : _pattern$slice$split.forEach((character, index) => {
    if (/x/.test(character)) {
      formattedText = setCharAt(formattedText, index, formattedText[index]);
    } else if (formattedText[index]) {
      formattedText = setCharAt(formattedText, index, character + formattedText[index]);
    }
  });
  return (_formattedText = formattedText) == null ? void 0 : _formattedText.slice(0, pattern.length);
};
export var numberMask = function numberMask(value, maskOptions) {
  var _String;

  if (value === void 0) {
    value = '';
  }

  var defaultMaskOptions = {
    locale: 'pt-BR',
    style: 'decimal',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  var newValue = (_String = String(value)) == null ? void 0 : _String.replace(/(\D)/g, '');

  var _defaultMaskOptions$m = _extends({}, defaultMaskOptions, maskOptions),
      {
    locale
  } = _defaultMaskOptions$m,
      intlOptions = _objectWithoutPropertiesLoose(_defaultMaskOptions$m, _excluded);

  var fractionDigits = Number(intlOptions.maximumFractionDigits);
  var numberToDivide = Number('1'.padEnd(fractionDigits + 1, '0'));

  if (maskOptions.style === 'percent') {
    newValue = Number(newValue) / 100;
  }

  newValue = Number(newValue) / numberToDivide;
  return new Intl.NumberFormat(locale, intlOptions).format(newValue);
};
//# sourceMappingURL=utils.js.map